module.exports = __webpack_public_path__ + "img/check.15ef0f8f.svg";